import React from "react";

import { BookingSearchInput } from "./BookingSearchInput";
import { BookingSearchResults } from "./BookingSearchResults";

import { RootDataType } from "../Helpers/interfaces";
import { FormDispatch, FormStateType } from "../Helpers/formTypes";

import { StepName } from "../Hooks/form";

interface BookingSearchProps {
  searchValue: string;
  setSearchValue: (val: string) => void;
  rootData: RootDataType;
  dispatch: FormDispatch;
  setStepByName: (stepName: StepName) => void;
  state: FormStateType;
}

export const BookingSearch: React.FC<BookingSearchProps> = ({
  searchValue,
  setSearchValue,
  rootData,
  dispatch,
  setStepByName,
  state,
}) => {
  return (
    <>
      <BookingSearchInput
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        location={state.location}
      />
      <BookingSearchResults
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        rootData={rootData}
        dispatch={dispatch}
        setStepByName={setStepByName}
        state={state}
      />
    </>
  );
};
